import { cn } from "@/utils";
import React from "react";

type Props = {
  text: React.ReactNode;
  className?: string;
  color?: string;
};

const SText: React.FC<Props> = ({ text, className, color = "tblack" }) => {
  return (
    <p className={cn(`text-md text-${color}`, className)}>
      {text}
    </p>
  );
};

export default SText;